module.exports = __webpack_public_path__ + "media/images/application/template/30-second-quote/6x2-flatpack-975fc29f7f20e3bb96f86f23ed8b2ff0.png";